import React, { useState } from 'react';
import { getClearButtonWrapper, parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';

export const SecretField = props => {
  // Use state to track the initial value of the visible prop, and set autoFocus
  // only when the field is initially not visible.
  const [allowAutoFocus] = useState(!props.visible);

  const renderOptions = parseRenderOptions(props);
  // Get wrapper information if clear button can be visible
  const {
    Tag,
    props: tagProps,
    content,
  } = getClearButtonWrapper(renderOptions, props);

  return (
    <FieldWrapper {...props} renderOptions={renderOptions} visible={true}>
      <Tag {...tagProps}>
        <input
          key={`secret-${props.visible}`}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'form-control--secret': !props.visible,
            'is-invalid': renderOptions.hasErrors,
            'has-btn': renderOptions.hasClear && !!props.value,
            'is-empty': !props.value,
          })}
          type="password"
          id={props.id}
          name={props.name}
          value={
            renderOptions.isFloating
              ? !props.visible
                ? '\u2022\u2022\u2022\u2022\u2022\u2022\u2022'
                : props.value
              : props.value
          }
          placeholder={
            !props.visible
              ? '\u2022\u2022\u2022\u2022\u2022\u2022\u2022'
              : renderOptions.placeholder || 'Enter a new secret'
          }
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          disabled={!props.enabled || !props.visible}
          form={props.form}
          // Autofocus when field is made visible if it started as not visible.
          // This will autoFocus the field when the Modify button is clicked, but
          // not when a new/blank secret field is part of a form and visible from
          // the start.
          autoFocus={allowAutoFocus && props.enabled && props.visible}
        />
        {content}
      </Tag>
    </FieldWrapper>
  );
};

export const ChangeSecretField = props => {
  const renderOptions = parseRenderOptions(props);
  return (
    props.visible && (
      <button
        disabled={!props.enabled}
        type="button"
        className={classNames('btn btn-outline-primary btn--secret-toggle', {
          'btn-sm': renderOptions.size === 'sm',
        })}
        onClick={() => props.onChange({ target: { checked: !props.value } })}
      >
        {props.value ? 'Cancel' : 'Modify'}
      </button>
    )
  );
};

export const SecretFieldGroup = ({
  secretField,
  changeSecretField,
  children,
}) => (
  <div className="form-group--secret">
    {secretField}
    {children}
    {changeSecretField}
  </div>
);
